import { PartnersSection } from './PartnersSection';

export type { TypePartnersSectionProps } from './types';
export default PartnersSection;
